

export const defaultForSessionSearchRequest = () => {
    return SessionSearchRequest.fromJS({
        searchText: '',
        includeDisabled: false
    });
}

export class SessionSearchRequest implements ISessionSearchRequest {
    searchText?: string | undefined;
    includeDisabled?: boolean;
    instructorPersonId?: string | undefined;
    accountId?: string | undefined;
    dateAddedFrom?: Date | undefined;
    dateAddedTo?: Date | undefined;

    constructor(data?: ISessionSearchRequest) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data['searchText'];
            this.includeDisabled = _data['includeDisabled'];
            this.instructorPersonId = _data['instructorPersonId'];
            this.accountId = _data['accountId'];
            this.dateAddedFrom = _data['dateAddedFrom'] ? new Date(_data['dateAddedFrom'].toString()) : <any>undefined;
            this.dateAddedTo = _data['dateAddedTo'] ? new Date(_data['dateAddedTo'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SessionSearchRequest {
        data = typeof data === 'object' ? data : {};
        const result = new SessionSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['searchText'] = this.searchText;
        data['includeDisabled'] = this.includeDisabled;
        data['instructorPersonId'] = this.instructorPersonId;
        data['accountId'] = this.accountId;
        data['dateAddedFrom'] = this.dateAddedFrom ? this.dateAddedFrom.toISOString() : <any>undefined;
        data['dateAddedTo'] = this.dateAddedTo ? this.dateAddedTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISessionSearchRequest {
    searchText?: string | undefined;
    includeDisabled?: boolean;
    instructorPersonId?: string | undefined;
    accountId?: string | undefined;
    dateAddedFrom?: Date | undefined;
    dateAddedTo?: Date | undefined;
}